/* State interfaces
 */
/* A single state change
 */
export class StateChange {
    key;
    oldValue;
    newValue;
    metadata;
    constructor(key, oldValue, newValue, metadata = {}) {
        this.key = key;
        this.oldValue = oldValue;
        this.newValue = newValue;
        this.metadata = metadata;
    }
    toString() {
        const keyStr = String(this.key);
        const oldValStr = this.oldValue === "null" ? "null" : String(this.oldValue);
        return `StateChange(${keyStr}, ${oldValStr}, ${this.newValue})`;
    }
}
/* A map of key:StateChange pairs
 */
export class StateChangeMap extends Map {
}
